import { get } from "lodash"

export const isTerminalPage = location => get(location, "pathname").indexOf("terminals") > 0

export const isScreenPage = location => get(location, "pathname").indexOf("screen") > 0
